// the translation files gets really messy with time
// to fix this, i added this file
// the types in here should act as a simple documentation for the translation files

import translationEnJSON from './en/translation-en.json';

type translationSectionsType = 'common';

type translationJsonType = Record<translationSectionsType, Record<string, string>>;

// the translations are a set of objects that should contain one level of keys
export const translationEn: translationJsonType = translationEnJSON;
